// extracted by mini-css-extract-plugin
export default {"mainWrap":"GrJYoRy9D5SXsZCUrhQt"};